import { Flex } from '@chakra-ui/react'

interface iModalProps {
  tipo: number
  tipoAtivo: number
  message: string
  onChangeTipo: (tipo: number) => void
}
export const TabButton: React.FC<iModalProps> = ({ tipo, onChangeTipo, message, tipoAtivo }) => {
  return (
      <Flex onClick={() => onChangeTipo(tipo)} p={'.25rem 1.325rem'} alignItems={'center'} cursor={'pointer'} borderRadius={'.25rem'} border={'2px solid var(--Azul)'} fontWeight={'600'} style={tipo === tipoAtivo ? { background: 'var(--Azul)', color: 'var(--c1)' } : { }} _hover={{ background: 'var(--Azul-hover) !important', transition: '.3s', color: 'var(--c1)' }}>{message}</Flex>
  )
}
